export default __webpack_public_path__ + "static/media/about.a9b2f369.svg";